import React, { useEffect, useState } from 'react'
import YouTube from 'react-youtube';
import axios from '../axios'
import "../Row.css"

const base_url = "https://image.tmdb.org/t/p/original/";

function Row({ title, fetchUrl }) {
    //title and fetch url are taken from the declared element in app.js and are unpacked here
    const [movies, setMovies] = useState([]);
    const [trailer, setTrailer] = useState("");
    const [movie, setMovie] = useState("");
    //Const options copy pasted option as listed by youtubeapp
    const opts = {
        height: "390",
        widht: "100%",
        playerVers: {
            autoplay: 1,
        }
    }
    const handleClick = (movie) => {
        if (trailer) {
            setTrailer('');
            setMovie('');
        } else {
            setTrailer('BCREjYfd4jE');
            setMovie(movie);
        }

    }
    //This will run when the condition inside the [] is changed
    useEffect(() => {
        //if [] are empty it will load once, if [fetchurl] it will load each time fetchurl changes
        async function fetchData() {
            const request = await axios.get(fetchUrl);
            //await is promise, it makes the function wait for the reponse from the server before continuing 
            setMovies(request.data.results);
            return request;
        }
        fetchData();
    }, [fetchUrl]);

    //console.table(movies);

    function truncate(str, n) {
        return (str?.length > n ? str.substr(0, n - 1) + "..." : str);
    }

    return (
        <div className="row">
            {/*Title*/}
            <h2>{title}</h2>

            {/*Container -> posters*/}
            <div className="row_posters">
                {/*several row_poster */}
                {movies.map(movie => (<img
                    key={movie.id}
                    onClick={() => handleClick(movie)}
                    className='row_poster'
                    src={`${base_url}${movie.poster_path}`}
                    alt={movie.name} ></img>))}
            </div>
            {(trailer || movie) && <div className='MovieInfo module-border-wrap'>
                <div className='module'>
                    {trailer && <YouTube id="video" videoId={trailer} opts={opts} />}
                    {movie &&
                        <div>
                            <h1 className='title'>{movie?.title || movie?.name || movie?.orignial_name}</h1>
                            <h1 className='info'>
                                {truncate(movie?.overview, 300)}
                            </h1>
                            <h1 className='rating'>Rating</h1>
                            <h1 className='score'>{movie?.vote_average}</h1>
                            <h1 className='votes'>Votes:{movie?.vote_count}</h1>
                        </div>
                    }
                </div>
            </div>
            }
        </div>
    )
}

export default Row



